import {register} from '@shopify/theme-sections';
import Swiper from 'swiper/bundle';

register('featured-blog-posts', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `.featured-blog-posts--${id}`;
    new Swiper(target, {
      slidesPerView: 4,
      loop: true,
      spaceBetween: 0,
      centeredSlides: false,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 55,
          centeredSlides: true,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        580: {
          slidesPerView: 2,
          spaceBetween: 0,
          centeredSlides: false,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        822: {
          slidesPerView: 3,
          spaceBetween: 10,
          centeredSlides: false,
        },
        1020: {
          slidesPerView: 4,
          spaceBetween: 10,
          centeredSlides: false,
        },
      },
    });
  },
});
